import { PrismicRichText } from '@prismicio/react';
import ContentContainer from 'remote-com-shared/components/ContentContainer';
import { fieldHasContent, transformProperties } from 'remote-com-shared/domains/prismic/helpers';
import { fluidProp } from 'remote-com-shared/style/helpers';
import styled from 'styled-components';

import { components } from '@/src/views/InternationalGlobalPayroll/slices//GlobalPayrollSlice';
import {
  Wrapper,
  Title,
  Description as DescriptionComponent,
} from '@/src/views/InternationalGlobalPayroll/slices/ManagePayrollSlice';

const Section = styled(Wrapper)`
  && {
    ${fluidProp(['padding-top', 'padding-bottom'], '70px', '105px')};
    background-color: var(--colors-blank);
    background-image: none;
  }

  ${Title} {
    max-width: 697px;
    margin: auto;
    text-align: center;
  }
`;

const Description = styled(DescriptionComponent)`
  padding-top: 20px;
`;

export function ServicesSlice({ slice }) {
  const { primary } = transformProperties(slice);
  const { manageTitle, manageDescription } = primary;

  return (
    <Section>
      <ContentContainer>
        {fieldHasContent(manageTitle) && (
          <Title>
            <PrismicRichText field={manageTitle} />
          </Title>
        )}
        {fieldHasContent(manageDescription) && (
          <Description>
            <PrismicRichText field={manageDescription} components={components} />
          </Description>
        )}
      </ContentContainer>
    </Section>
  );
}
